<template>
  <div class="objective-card">
    <button
      class="objective-card__wrapper"
      data-testid="objective-card"
      @click="emitClick"
      @mouseenter="handleEnter"
      @mouseleave="handleLeave"
    >
      <div class="objective-card__base">
        <ProgressiveImage
          v-if="hasImage"
          class="objective-card__base-image"
          :placeholder="image"
          :image="image"
        />
        <div v-else class="objective-card__base-placeholder" />
        <div class="objective-card__base-content">
          <ChipContext
            :label="hasHover ? 'Gestão Warren' : ''"
            icon="G0010"
            context="brand"
            :class="{
              'objective-card__base-chip-context': true,
              'objective-card__base-chip-context--hover': hasHover
            }"
          />
          <div>
            <BaseText size="sm" :color="NebraskaColors.textOverImage">
              {{ head }}
            </BaseText>
            <Heading
              :level="3"
              class="objective-card__base-title"
              :title="title"
            >
              {{ title }}
            </Heading>
          </div>
        </div>
      </div>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, Heading, ChipContext } from '@warrenbrasil/nebraska-web';
import { ProgressiveImage } from '@/modules/common/components/ProgressiveImage';

interface EmitEvents {
  (event: 'click'): void;
}
const emit = defineEmits<EmitEvents>();

interface Props {
  image: string;
  head: string;
  title: string;
}
const props = defineProps<Props>();

const hasHover = ref(false);

const hasImage = computed(() => {
  return !!props.image;
});

function handleEnter() {
  hasHover.value = true;
}

function handleLeave() {
  hasHover.value = false;
}

function emitClick() {
  emit('click');
}
</script>

<style lang="less" scoped>
button {
  width: 100%;
  height: 100%;
  padding: 0;
}

.objective-card {
  &__wrapper {
    display: block;
    height: 54vw;
    max-height: 454px;
    position: relative;
    transform: translate3d(0, 0, 1px);
    z-index: 10;
  }

  &__base {
    position: relative;
    padding: @size-spacing-x500;
    border-radius: @size-radius-x400;
    min-height: 100%;
    min-width: 100%;
    text-align: left;
    display: flex;
    flex-direction: column;

    &-title {
      color: @text-over-image;
      margin-bottom: @size-spacing-x400;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-all;
    }

    &-chip-context {
      align-self: flex-start;
      padding: @size-spacing-x150 @size-spacing-x150;
      color: @status-brand;

      :deep(.chip--icon) {
        margin-right: 0;
      }

      &--hover :deep(.chip--icon) {
        margin-right: @size-spacing-x150;
      }

      :deep(svg) {
        height: 18px !important;
        width: auto !important;
      }
    }

    &-content {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex-grow: 1;
    }

    &-placeholder {
      position: absolute;
      z-index: 1;
      border-radius: inherit;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: @background-overlay;
    }

    &-image {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &:hover :deep(img) {
      transform: scale(1.1);
    }
  }
}
</style>
